import hexToRgba from 'hex-to-rgba';

import colours from '~/utils/colours';
import { theme as container } from '~/App/Components/DropdownPanel';

export const item = {
  color: colours.greyDark,
  bgColor: 'white',
  padding: '5px 15px',

  hover: {
    color: colours.greyDark,
    bgColor: colours.greyLightAlt,
  },
};

export const itemActive = {
  color: colours.greyLight,
  bgColor: colours.grey,
  padding: '5px 15px',
};

export const itemDisabled = {
  color: hexToRgba(colours.greyMediumDark, 0.25),
  bgColor: 'white',
  padding: '5px 15px',
};

export const itemDanger = {
  ...item,

  color: colours.redDark,

  hover: {
    color: colours.redDark,
    bgColor: colours.redLight,
  },
};

const grey = {
  bg: 'white',
  fg: colours.greyMediumDark,
  borderColor: colours.greyLight,

  container,

  item,
  itemActive,
  itemDanger,
  itemDisabled,
};

export default grey;
